import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { Spin, Select } from 'antd';
import AvailabilitiesQuery from '../../../components/Query/Availabilities';
import { FormItem } from '../../../components/Form';

interface IAvailabilitySelectProps extends RouteComponentProps<{
  eshop: string;
}> {
  name?: string;
  label?: string;
  required?: boolean;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  onChange?: Function;
}

class AvailabilitySelect extends React.Component<IAvailabilitySelectProps> {

  constructor(props: IAvailabilitySelectProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  public render() {
    const { label, required, value, placeholder, disabled } = this.props;

    return (
      <AvailabilitiesQuery
        domain={this.props.match.params.eshop}
      >
        {({ availabilities }: any) => {
          if (availabilities.loading) {
            return (
              <div>
                <Spin /> Loading availabilities ...
              </div>
            );
          }

          return (
            <FormItem
              label={label}
              required={required}
            >
              <Select
                showSearch={true}
                style={{ width: '100%' }}
                onChange={this.onChange}
                placeholder={placeholder}
                defaultValue={value}
                allowClear={true}
                disabled={disabled}
              >
                {(availabilities.availabilities || []).map((a: GQL.IAvailability) => {
                  return (
                    <Select.Option key={a.id} value={a.id}>
                      {a.name}
                    </Select.Option>
                  );
                })}
              </Select>
            </FormItem>
          );
        }}
      </AvailabilitiesQuery>
    );
  }

  private onChange(value: any) {
    if (this.props.onChange) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value,
        }
      });
    }
  }
}

export default withRouter(AvailabilitySelect);


// WEBPACK FOOTER //
// ./src/scenes/Availabilities/AvailabilitySelect/AvailabilitySelect.tsx